var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnFavouriteUserOptionDesktop(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "25px",
    viewBox: "0 0 26 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "unFavouriteUserOptionDesktop") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M24.9277515,11.8016675 C25.4198363,11.3220976 25.5935427,10.6182613 25.3812905,9.9639838 C25.1685377,9.30970632 24.6143792,8.84265132 23.9335702,8.74353354 L17.8803771,7.86398837 C17.6225708,7.82644376 17.3998061,7.66475162 17.2846693,7.43097382 L14.5784535,1.94645656 C14.2745924,1.33022429 13.6578595,0.947269229 12.9705428,0.947269229 C12.2837266,0.947269229 11.6669938,1.33022429 11.3631327,1.94645656 L8.6564163,7.43147442 C8.54127948,7.66525221 8.31801417,7.82694435 8.06020782,7.86448897 L2.00701481,8.74403413 C1.3267064,8.84265132 0.772047294,9.31020691 0.559294479,9.96448439 C0.34704226,10.6187619 0.520748675,11.3225982 1.01283342,11.8021681 L5.39253783,16.0712411 C5.57925971,16.2534576 5.66486143,16.5157693 5.62080908,16.7720739 L4.5875813,22.8002371 C4.49597244,23.3308677 4.63513781,23.846981 4.97854588,24.2539646 C5.51218,24.8882183 6.44378703,25.0814479 7.18867217,24.6899827 L12.602105,21.8436004 C12.8283738,21.7249594 13.1132123,21.7259606 13.3389806,21.8436004 L18.752914,24.6899827 C19.0162269,24.8286475 19.2970606,24.8987308 19.586905,24.8987308 C20.1160338,24.8987308 20.6176298,24.6634512 20.9625397,24.2539646 C21.3064483,23.846981 21.4451131,23.3298665 21.3535043,22.8002371 L20.3197759,16.7720739 C20.2757235,16.5152687 20.3613252,16.2534576 20.5480471,16.0712411 L24.9277515,11.8016675 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "RHP-Search--Desktop-v2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Profile-5-Dropdown---After-interaction",
    transform: "translate(-677.000000, -398.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Option-popUp",
    transform: "translate(658.000000, 249.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PopUpMenu"
  }, /*#__PURE__*/React.createElement("g", {
    id: "unFavouriteUserOptionDesktop",
    transform: "translate(19.000000, 149.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "colour/dark-grey"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#10C2E1",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnFavouriteUserOptionDesktop);
export default __webpack_public_path__ + "static/media/unFavouriteUserOptionDesktop.9d74ea3bfe816f274ade4c447f6248a4.svg";
export { ForwardRef as ReactComponent };